import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Quiz from "@/pages/Quiz";
import LeadCapture from "@/pages/LeadCapture";
import Processing from "@/pages/Processing";
import Results from "@/pages/Results";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/lead-capture" element={<LeadCapture />} />
          <Route path="/processing" element={<Processing />} />
          <Route path="/results/:id" element={<Results />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
